export const loadChart = Function(
	"cBF",
	'(async()=>{if(window.Chart)return cBF();try{await import("../modules/chartjs/Chart.min.js");cBF();}catch(ex){console.error(ex);}finally{cBF();}})()'
);
